import React from "react";
import styled from "styled-components";
const ImageUploadContainer = styled("label")<{ align: string }>`
  border-radius: 50%;
  border-style: none;
  background-size: 20px 20px;
  &:active {
    transform: scale(0.98);
    box-shadow: 3px 2px 22px 1px rgba(0, 0, 0, 0.24);
  }
  &:hover {
    cursor: pointer;
  }
  align-self: ${(props) => props.align};
`;
interface ImageUploadProps {
  onImageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  bg: string;
  // Default is center
  align?: string;
  position?: string;
  htmlFor: string;
}

const ImageButton = styled("img")<{
  position?: string
}>`
position: ${(props) => props.position ?? "relative"};
 bottom: 0; 
 right: 0;
`;

const ImageUploadButton: React.FC<ImageUploadProps> = ({
  onImageChange,
  bg,
  align,
  htmlFor, 
  position
}) => {
  return (
    <ImageUploadContainer align={align ? align : "center"} htmlFor={htmlFor}>
      <input
        style={{ display: "none" }}
        accept="image/*"
        id={htmlFor}
        type="file"
        onChange={onImageChange}
      />
      <ImageButton position={position} src={bg} width={"25px"} height={"25px"}/>
    </ImageUploadContainer>
  );
};

export default ImageUploadButton;
